import { useActiveAccount } from '@/store/active-account/active-account.store';
import { useCurrentServiceProvider } from '@/store/service-providers/current-service-provider.store';
import { useVessels } from '@/store/vessels/vessels.store';

const deriveAccountFields = () => {
  const { serviceId, serviceType } = useActiveAccount.getState();

  const { vessel, myVessels, ownedVessels } = useVessels.getState();
  const nextVessel =
    serviceType === 'vessel' && serviceId
      ? (myVessels?.find((v) => v.id === serviceId) ??
        ownedVessels?.find((v) => v.id === serviceId))
      : undefined;
  if (nextVessel !== vessel) {
    useVessels.setState({ vessel: nextVessel });
  }

  const nextServiceProviderId = serviceType === 'service-provider' ? serviceId : undefined;
  if (nextServiceProviderId !== useCurrentServiceProvider.getState().selectedServiceProviderId) {
    useCurrentServiceProvider.setState({ selectedServiceProviderId: nextServiceProviderId });
  }
};

let initialized = false;

export const initActiveAccountSync = () => {
  if (initialized) return;
  initialized = true;

  useActiveAccount.subscribe(deriveAccountFields);

  useVessels.subscribe((state, prev) => {
    if (state.myVessels !== prev.myVessels || state.ownedVessels !== prev.ownedVessels) {
      deriveAccountFields();
    }
  });

  deriveAccountFields();
};
